<!-- La fenêtre porte elle-même sa mise en page : corps défilant, pied fixe. Sans
     cela, le bouton de sortie remonterait au milieu de l'article dès que celui-ci
     dépasse la hauteur de la fenêtre. -->
<div class="doc-ui doc-dialog">

    <div class="doc-dialog__body no-scrollbars" [class.doc-dialog__body--conv]="inConversation">
        @if (!inConversation) {
        <app-documentation-article-view class="h-auto" [dense]="true" [articleId]="articleId" [anchor]="anchor"
            (openArticle)="onOpenArticle($event)" (articleLoaded)="onLoadArticle($event)">
        </app-documentation-article-view>
        }

        <!-- La conversation prend la place de l'article : la fenêtre ne s'agrandit
             pas, le fil remplit sa hauteur — champ de saisie en bas — et le pied
             porte le retour -->
        @if (inConversation) {
        <div class="flex flex-none align-items-center gap-2 mb-3">
            <span class="doc-res__section"><i class="bi bi-ai-sparkles-solo text-purple-500"></i>Assistant du
                manuel</span>
        </div>
        <app-documentation-assistant class="flex flex-column flex-1 h-auto min-h-0" [fill]="true"
            [context]="assistantContext" (openDoc)="onOpenDoc($event)"></app-documentation-assistant>
        }
    </div>

    <div class="doc-dialog__foot">
        @if (!inConversation) {
        <p-button label="Demander à l'assistant" icon="bi bi-ai-sparkles-solo" severity="help" [rounded]="true"
            size="small" (onClick)="onClickAskAssistant()"></p-button>
        <p-button label="Ouvrir dans la documentation" icon="fa-solid fa-book-open" [text]="true" [rounded]="true"
            (onClick)="onClickOpenInDocumentation()"></p-button>
        } @else {
        <p-button label="Revenir à l'article" icon="pi pi-arrow-left" severity="secondary" [text]="true"
            [rounded]="true" (onClick)="onClickBackToArticle()"></p-button>
        }
    </div>
</div>
